import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import { Layout } from './components/Layout';
import './custom.css';
import { ClaimGuardRoute } from './components/ClaimGuardRoute';
import authService from './components/api-authorization/AuthorizeService';

export default function App() {
  const [user, setUser] = useState(null);
  const [userLoaded, setUserLoaded] = useState(false);

  useEffect(() => {
    let active = true;

    const load = async () => {
      try {
        const u = await authService.getUser();
        if (active) setUser(u || null);
      } catch {
        if (active) setUser(null);
      } finally {
        if (active) setUserLoaded(true);
      }
    };
    load();

    const sub = authService.subscribe(async () => {
      try {
        const u = await authService.getUser();
        if (active) setUser(u || null);
      } catch {
        if (active) setUser(null);
      }
    });

    return () => { active = false; authService.unsubscribe(sub); };
  }, []);

  return (
    <Layout>
      <Routes>
        {AppRoutes.map((route, index) => {
          const { element, requireAuth, requiredClaim, ...rest } = route;
          let guardedElement = element;
          if (requiredClaim) {
            guardedElement = (
              <ClaimGuardRoute user={user} loading={!userLoaded} requiredClaim={requiredClaim} element={element} />
            );
          }
          return (
            <Route
              key={index}
              {...rest}
              element={requireAuth ? <AuthorizeRoute {...rest} element={guardedElement} /> : guardedElement}
            />
          );
        })}
      </Routes>
    </Layout>
  );
}
